module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-00.c63f8e09.png";